import {
  registerEventSectionTransitionHandler,
  registerCountdownAnimation,
  loadEventInformation,
} from "./event.js";
import { loadGalleryImages } from "./gallery.js";
import { registerPageTransitions } from "./page-transition.js";

document.addEventListener("DOMContentLoaded", () => {
  registerPageTransitions();
  registerToggleMusicHandler();
  loadGalleryImages();

  // Load event information and then register the transition handler
  // This ensures the event information is loaded before any transitions occur
  loadEventInformation();
  setTimeout(() => {
    registerEventSectionTransitionHandler();
  });
});

function registerToggleMusicHandler() {
  const toggleButton = document.getElementById("audio-play-toggle");
  toggleButton.addEventListener("click", () => {
    const audioPlayer = document.getElementById("audio-player");
    if (audioPlayer) {
      if (audioPlayer.paused) {
        audioPlayer.play();
        toggleButton.classList.remove("muted");
      } else {
        audioPlayer.pause();
        toggleButton.classList.add("muted");
      }
    }
  });
}
